import { render, staticRenderFns } from "./ShareField.vue?vue&type=template&id=6d2cca40"
import script from "./ShareField.vue?vue&type=script&lang=js"
export * from "./ShareField.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports